<script lang="ts">
    import {dyData, modal} from 'general/store';

    import s from './style.module.css';

    export let template = 'circle';
</script>

<div
    class="{s.wrapper} {s[template] || ''}"
    class:s.bigPicture={$dyData.side?.[$modal.state]?.isBigImage}
    style="height: {$dyData.side?.[$modal.state]?.height};"
>
    <slot />
</div>
